<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-input ttLabel="filterval" ttFocus="true" [(ttModel)]="setting.filterval" ttShowClearButton></tt-input>
            <tt-button-goto ttText="colorgrps_new" ttGoto="colorgrp" [ttGotoParms]="{ colorgrp_id: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListViews" [ttFilter]="setting.filterval"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <tt-input ttLabel="filterval" ttFocus="true" [(ttModel)]="setting.filterval" ttShowClearButton></tt-input>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="colorgrps_new" ttGoto="colorgrp" [ttGotoParms]="{ colorgrp_id: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <tt-list class="col-xs-12 col-md-4 p-5" [ttData]="itemsListViews" [ttFilter]="setting.filterval"></tt-list>
    </div>
</tt-page>
